<template>
  <b-modal
    id="food-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer un aliment"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
    :hide-footer="!canBeDeleted"
  >
    <div v-if="selectedFood !== null">
      <div v-if="canBeDeleted">
        Supprimer l'aliment "{{selectedFood.name}}" ?
      </div>
      <div v-else>
        L'aliment "{{selectedFood.name}}" ne peut pas être supprimé car il est associé à un ou plusieurs états quotidiens.
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'FoodDeleteModal',

  props: {
    selectedFood: Object
  },

  computed: {
    canBeDeleted() {
      if (this.selectedFood === null) {
        return false
      }
      return this.selectedFood.dailyFoodsCount === 0
    }
  },

  emits: ['didDeleteFood'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {

      let foodName = this.selectedFood.name

      api
        .delete(`/food/${this.selectedFood.id}`)
        .then(response => {
          this.$emit('didDeleteFood')
          this.hideModal()
          this.successToast(`Food \"${foodName}\" supprimé`)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('food-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/food/FoodDeleteModal.vue